export var PermissionsDomains;
(function (PermissionsDomains) {
    PermissionsDomains["ACCOUNT"] = "account";
    PermissionsDomains["AUTHORIZATION"] = "authorization";
    PermissionsDomains["BENEFITS"] = "benefits";
    PermissionsDomains["BILLING"] = "billing";
    PermissionsDomains["DIGITAL_ACCOUNTING"] = "digital_accounting";
    PermissionsDomains["INSTRUCTION"] = "instruction";
    PermissionsDomains["DOMINIO_RECOMPENSAS"] = "fidelity_program";
    PermissionsDomains["CLIENT_PORTAL"] = "client_portal";
})(PermissionsDomains || (PermissionsDomains = {}));
export var PermissionsResources;
(function (PermissionsResources) {
    PermissionsResources["ACCOUNT_VIEW_BALANCE"] = "account.view-balance";
    PermissionsResources["ACCOUNT_VIEW_STATEMENTS"] = "account.view-statements";
    PermissionsResources["AUTHORIZATION_CREATE_OPERATOR"] = "authorization.create-operator";
    PermissionsResources["AUTHORIZATION_REMOVE_OPERATOR"] = "authorization.remove-operator";
    PermissionsResources["AUTHORIZATION_VIEW_OPERATOR_LIST"] = "authorization.view-operator-list";
    PermissionsResources["BENEFITS_CREATE_RECHARGE"] = "benefits.create-recharge";
    PermissionsResources["BENEFITS_CREATE_VOUCHER_CONTRACT"] = "benefits.create-voucher-contract";
    PermissionsResources["BENEFITS_VIEW_RECHARGES"] = "benefits.view-recharges";
    PermissionsResources["BENEFITS_VIEW_BENEFICIARIES"] = "benefits.view-beneficiaries";
    PermissionsResources["BILLING_VIEW_BILLING"] = "billing.view-billings";
    PermissionsResources["BILLING_CREATE_BILLING"] = "billing.create-billings";
    PermissionsResources["BILLING_CANCEL_BILLING"] = "billing.cancel-billings";
    PermissionsResources["BILLING_VIEW_TARIFFS"] = "billing.view-tariffs";
    PermissionsResources["DIGITAL_ACCOUNTING_VIEW_CONSENTS"] = "digital_accounting.view-consents";
    PermissionsResources["INSTRUCTION_CREATE_PIX_OUT"] = "instruction.create-pix-out";
    PermissionsResources["INSTRUCTION_CREATE_BANKSLIP"] = "instruction.create-bankslip";
    PermissionsResources["INSTRUCTION_APPROVE_SCHEDULED_PIX"] = "instruction.approve-scheduled-pix";
    PermissionsResources["INSTRUCTION_APPROVE_SCHEDULED_BANKSLIP"] = "instruction.approve-scheduled-bankslip";
    PermissionsResources["INSTRUCTION_APPROVE_PIX_OUT"] = "instruction.approve-pix-out";
    PermissionsResources["INSTRUCTION_APPROVE_BANKSLIP"] = "instruction.approve-bankslip";
    PermissionsResources["INSTRUCTION_REPROVE_PIX_OUT"] = "instruction.reprove-pix-out";
    PermissionsResources["INSTRUCTION_REPROVE_BANKSLIP"] = "instruction.reprove-bankslip";
    PermissionsResources["INSTRUCTION_VIEW_PENDING_PAYMENTS"] = "instruction.view-pending-payments";
    PermissionsResources["FIDELITY_PROGRAM_ENABLE_PROGRAM"] = "fidelity_program.enable-program";
    PermissionsResources["FIDELITY_PROGRAM_RETRIEVE_POINTS"] = "fidelity_program.retrieve-points";
    PermissionsResources["FIDELITY_PROGRAM_VIEW_BALANCE"] = "fidelity_program.view-balance";
    PermissionsResources["FIDELITY_PROGRAM_VIEW_PROGRAM"] = "fidelity_program.view-program";
    PermissionsResources["FIDELITY_PROGRAM_VIEW_STATEMENT"] = "fidelity_program.view-statement";
    PermissionsResources["CLIENT_PORTAL_VIEW_PORTAL"] = "client_portal.view-portal";
})(PermissionsResources || (PermissionsResources = {}));
export var ConditionParameter;
(function (ConditionParameter) {
    ConditionParameter["AMOUNT"] = "AMOUNT";
})(ConditionParameter || (ConditionParameter = {}));
export var ConditionOperator;
(function (ConditionOperator) {
    ConditionOperator["LE"] = "LE";
})(ConditionOperator || (ConditionOperator = {}));
export var ResourceBehavior;
(function (ResourceBehavior) {
    ResourceBehavior["OR"] = "OR";
    ResourceBehavior["AND"] = "AND";
})(ResourceBehavior || (ResourceBehavior = {}));
export var RegisterOperatorErrors;
(function (RegisterOperatorErrors) {
    RegisterOperatorErrors["OPERATOR_ALREADY_REGISTERED"] = "OPERATOR_ALREADY_REGISTERED";
    RegisterOperatorErrors["GENERIC"] = "BUSINESS_ERROR";
})(RegisterOperatorErrors || (RegisterOperatorErrors = {}));
